import { couponMaxAge } from '@/utils/constants'
import { useRootStore } from '@/stores/useRootStore'

export default function ({ route, app, store }) {
  // Skip coupon code processing during SSR to prevent caching issues
  if (process.server) {
    return
  }

  // Support both 'd' parameter (legacy) and 'couponCode' parameter
  const { d: dParam = '', couponCode: couponCodeParam = '' } = route.query
  const routeCouponCode = dParam || couponCodeParam
  const cookiesCouponCode = app.$cookies.get('couponCode')
  const couponCode = routeCouponCode || cookiesCouponCode

  if (couponCode) {
    // Set coupon code in both stores to ensure compatibility during migration
    // Set in Vuex store (still used by some components)
    store.dispatch('setCouponCode', couponCode)

    // Also set in Pinia store (used by category/brand pages)
    if (app.$pinia) {
      const rootStore = useRootStore()
      rootStore.setCouponCode(couponCode)
    }
  }

  if (routeCouponCode) {
    app.$cookies.set('couponCode', routeCouponCode, { maxAge: couponMaxAge })
  }
}
